import React from "react";
import WarningIcon from "@mui/icons-material/Warning";

interface IProps {
  callBack: (YesorNo: boolean) => void;
}

const YesNoAlert: React.FC<IProps> = (props) => {
  const handleYes = () => {
    console.log("User clicked Yes");
    props.callBack(true);
  };

  const handleNo = () => {
    console.log("User clicked No");
    props.callBack(false);
  };

  return (
    <>
      <WarningIcon sx={{ color: "orange", fontSize: 60 }} />
      <h5
        style={{
          margin: "1.5rem",
          textAlign: "center",
        }}
      >
        Do you want to delete the file?
      </h5>
      <div>
        <button
          className="btn"
          style={{
            margin: "2rem",
            paddingLeft: "2rem",
            paddingRight: "2rem",
            background: "orange",
            color: "#FFFFFF",
          }}
          onClick={handleYes}
        >
          Yes
        </button>
        <button
          className="btn"
          style={{
            margin: "2rem",
            paddingLeft: "2rem",
            paddingRight: "2rem",
            background: "#757575",
            color: "#FFFFFF",
          }}
          onClick={handleNo}
        >
          No
        </button>
      </div>
    </>
  );
};

export default YesNoAlert;
